import { useEffect, useMemo, useState } from "react";
import { subscribeFolderSnapshotsChanged } from "@/lib/mail/inboxFolderBus";
import { mergeFoldersWithSnapshotUnread } from "@/lib/mail/folderSnapshotUnread";
import type { MailFolder } from "@/lib/types/mail";

/** Pastilles sidebar alignées sur les en-têtes chargés (liste + IMAP). */
export function useFoldersWithSnapshotUnread(accountId: number, folders: MailFolder[]) {
  const [revision, setRevision] = useState(0);

  useEffect(() => {
    return subscribeFolderSnapshotsChanged((snap) => {
      if (snap.accountId === accountId) {
        setRevision((v) => v + 1);
      }
    });
  }, [accountId]);

  return useMemo(
    () => mergeFoldersWithSnapshotUnread(accountId, folders),
    [accountId, folders, revision]
  );
}
